module.exports = __webpack_public_path__ + "static/media/stock-in.50443bca.svg";